import React, { useMemo, type PropsWithChildren } from 'react';

import { FabricElementsAnalyticsContext } from '@atlaskit/analytics-namespaced-context';
import { getUserLocation } from '@atlassian/jira-platform-router-utils/src/common/utils/index.tsx';
import { useIsAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-admin/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { useProjectContext } from '@atlassian/jira-providers-project-context/src/index.tsx';
import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils';
import { ContextualAnalyticsData } from '@atlassian/jira-product-analytics-bridge';
import {
	COMPANY_MANAGED_PROJECT,
	TEAM_MANAGED_PROJECT,
} from '@atlassian/jira-common-constants/src/project-types.tsx';
import { AnalyticsWrapper } from './AnalyticsWrapper.tsx';

const BaseShareButtonAnalyticsWrapper = ({ children }: PropsWithChildren<{}>) => {
	const { data } = useProjectContext();
	const projectKey = data?.projectKey || '';
	const projectType = data?.projectType;
	const projectStyle = data?.simplified ? TEAM_MANAGED_PROJECT : COMPANY_MANAGED_PROJECT;
	const userLocation = getUserLocation();
	const isAdmin = useIsAdmin();
	const isProjectAdmin = data?.isProjectAdmin || false;

	const analyticsData = useMemo(() => {
		const projectContextData = projectKey
			? { projectType, projectStyle, isProjectAdmin }
			: undefined;

		return {
			isAdmin,
			userLocation,
			...projectContextData,
		};
	}, [projectKey, projectType, projectStyle, isProjectAdmin, userLocation, isAdmin]);

	return (
		<ContextualAnalyticsData attributes={analyticsData}>
			<FabricElementsAnalyticsContext data={analyticsData}>
				{children}
			</FabricElementsAnalyticsContext>
		</ContextualAnalyticsData>
	);
};

export const ShareButtonAnalyticsWrapper = componentWithCondition(
	() => fg('share_dialog_improvements_2'),
	AnalyticsWrapper,
	BaseShareButtonAnalyticsWrapper,
);
